import { render, staticRenderFns } from "./SupportFAQBox.vue?vue&type=template&id=78f65b07&scoped=true"
import script from "./SupportFAQBox.vue?vue&type=script&lang=js"
export * from "./SupportFAQBox.vue?vue&type=script&lang=js"
import style0 from "./SupportFAQBox.vue?vue&type=style&index=0&id=78f65b07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f65b07",
  null
  
)

export default component.exports